import { makeStyles } from '@fluentui/react-components';
import { tokens } from '../../../../../theme/fluent';

const widgetContentRendererStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flexGrow: 1,
  },
  list: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
    columnGap: tokens.spacingHorizontalS,
    overflowY: 'scroll',
    marginRight: `-7px`,
    paddingRight: '1px',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      visibility: 'hidden',
    },
    '&:hover::-webkit-scrollbar': {
      visibility: 'visible',
    },
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      display: 'block',
    },
  },
});

export const useWidgetContentRendererStyles = () => {
  const classes = widgetContentRendererStyle();
  return { classes };
};
